/*
 * EONA Pill-Dekoration: Staffelpreis-Hints (je Vial + Ersparnis) und
 * "Bester Vial-Preis"-Badge auf der 10er-Stufe. Das fruehere "Beliebt"-Badge
 * ist bewusst entfernt (unbelegte Zuschreibung bei 0 Bestelldaten).
 * Zusaetzlich: oeffnet das Akkordeon "Versand & Lieferung" beim Seitenaufbau.
 * Preise kommen live aus /products/{handle}.js, veralten also nie.
 */
(() => {
  if (window.__eonaVariantBadgeMarker) {
    window.__eonaVariantBadgeMarker();
    return;
  }

  const productCache = new Map();
  let isScheduled = false;
  let shippingOpened = false;

  const euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

  const extractPackFromLabel = (label) => {
    const match = label.match(/\b(1|3|5|10)\s*vials?\b/);
    return match ? match[1] : null;
  };

  const unitsFromTitle = (title) => {
    const match = String(title || '').match(/\b(\d{1,2})\s*vials?\b/i);
    return match ? parseInt(match[1], 10) : 1;
  };

  const getProduct = (handle) => {
    if (!handle) {
      return null;
    }

    if (productCache.has(handle)) {
      return productCache.get(handle) || null;
    }

    productCache.set(handle, null);

    fetch(`/products/${handle}.js`, { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Product JSON failed: ${response.status}`);
        }
        return response.json();
      })
      .then((product) => {
        productCache.set(handle, product);
        window.__eonaVariantBadgeMarker();
      })
      .catch(() => {
        productCache.set(handle, false);
      });

    return null;
  };

  const decorateSwatches = () => {
    document.querySelectorAll('.variant-picker__option-values').forEach((group) => {
      const picker = group.closest('variant-picker');
      const handle = picker?.getAttribute('handle') || '';
      const product = getProduct(handle);

      group.querySelectorAll('.block-swatch').forEach((swatch) => {
        const nameSpan = swatch.querySelector('span');
        const label = (nameSpan?.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        const pack = extractPackFromLabel(label);

        if (pack === '10') {
          swatch.setAttribute('data-eona-pack-badge', 'best-price');
        } else if (swatch.hasAttribute('data-eona-pack-badge')) {
          swatch.removeAttribute('data-eona-pack-badge');
        }

        if (!product || !product.variants || !pack) {
          return;
        }

        const units = parseInt(pack, 10);

        if (units <= 1) {
          return;
        }

        const variant = product.variants.find((v) => unitsFromTitle(v.title) === units);
        const baseVariant = product.variants.find((v) => unitsFromTitle(v.title) === 1);

        if (!variant || !baseVariant) {
          return;
        }

        const perVialCents = Math.round(variant.price / units);
        const savingCents = baseVariant.price * units - variant.price;
        const perText = `je ${euro.format(perVialCents / 100)}`;
        const saveText = savingCents > 0 ? `spart ${euro.format(savingCents / 100)}` : '';
        const desiredState = `${perText}|${saveText}`;

        let hint = swatch.querySelector('.eona-tier');

        if (hint && hint.dataset.eonaTierState === desiredState) {
          return;
        }

        if (!hint) {
          hint = document.createElement('span');
          hint.className = 'eona-tier';
          swatch.appendChild(hint);
        }

        hint.dataset.eonaTierState = desiredState;
        hint.textContent = '';

        const per = document.createElement('span');
        per.className = 'eona-tier-per';
        per.textContent = perText;
        hint.appendChild(per);

        if (saveText) {
          const save = document.createElement('span');
          save.className = 'eona-tier-save';
          save.textContent = saveText;
          hint.appendChild(save);
        }
      });
    });
  };

  const openShippingAccordion = () => {
    if (shippingOpened) {
      return;
    }

    const details = [...document.querySelectorAll('.shopify-section--main-product details.accordion__disclosure')]
      .find((d) => /Versand\s*&\s*Lieferung/i.test(d.querySelector('summary')?.textContent || ''));

    if (details) {
      details.setAttribute('open', '');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
      shippingOpened = true;
    }
  };

  const run = () => {
    isScheduled = false;
    decorateSwatches();
    openShippingAccordion();
  };

  const scheduleMark = () => {
    if (isScheduled) {
      return;
    }

    isScheduled = true;
    window.requestAnimationFrame(run);
  };

  window.__eonaVariantBadgeMarker = scheduleMark;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleMark, { once: true });
  } else {
    scheduleMark();
  }

  document.addEventListener('shopify:section:load', scheduleMark);

  const observer = new MutationObserver(scheduleMark);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();


/* === EONA Warenkorb-Modul v3 (13.08.2026): Geschenk-Treppe + Trust-Stack ===
   Treppe nach Smart-Muster, Stufen compliance-gefiltert (KEIN Injektionszubehör,
   kein GLP-1 als Geschenk). Stufen sind Lukas-Vorschlag, Publish-Gate: Stufen
   bestaetigen + Fulfillment-Beilage operativ zusichern.
   EONA_GIFT_TIERS = null zeigt wieder den einfachen Fortschrittsbalken.
   EONA_PAYMENT_ROW = null schaltet die Zahlungs-Zeile ab (Compliance-Gate). */
(() => {
  const EONA_GIFT_TIERS = [
    { cents: 9900, label: 'Gratisversand' },
    { cents: 15000, label: 'Bac Water 10 ml gratis' },
    { cents: 30000, label: 'GHK-Cu 50 mg gratis' },
    { cents: 50000, label: 'NAD+ 500 mg gratis' }
  ];
  const EONA_TRUST_ROWS = [
    ['Versand', 'werktags in 24 h'],
    ['Chargen-COA', 'liegt jeder Lieferung bei']
  ];
  const EONA_PAYMENT_ROW = ['Zahlung', 'Karte, Apple Pay, Google Pay'];

  const euro = cents => (cents / 100).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' \u20AC';

  const renderFsb = () => {
    document.querySelectorAll('free-shipping-bar').forEach(bar => {
      const threshold = parseInt(bar.getAttribute('threshold'), 10);
      const total = parseInt(bar.getAttribute('total-price'), 10);
      if (!threshold || isNaN(total)) return;
      if (EONA_GIFT_TIERS && EONA_GIFT_TIERS.length) {
        bar.style.display = 'none';
        renderTiers(bar, total);
        return;
      }
      const pct = Math.max(0, Math.min(100, Math.round(total / threshold * 100)));
      let track = bar.querySelector('.eona-fsb-track');
      if (!track) {
        track = document.createElement('span');
        track.className = 'eona-fsb-track';
        track.innerHTML = '<span class="eona-fsb-fill"></span>';
        bar.appendChild(track);
      }
      track.querySelector('.eona-fsb-fill').style.width = pct + '%';
    });
  };

  const renderTiers = (bar, total) => {
    let wrap = bar.nextElementSibling;
    if (!wrap || !wrap.classList.contains('eona-gifts')) {
      wrap = document.createElement('div');
      wrap.className = 'eona-gifts';
      bar.insertAdjacentElement('afterend', wrap);
    }
    // Re-Render nur bei geaendertem Stand, sonst feuert der MutationObserver
    // auf das eigene innerHTML und die Seite haengt in einer Endlosschleife
    const sig = String(total);
    if (wrap.dataset.eonaSig === sig) return;
    wrap.dataset.eonaSig = sig;
    const rows = [];
    rows.push('<p class="eona-gifts__title">Deine Geschenke</p>');
    let aktivGesetzt = false;
    EONA_GIFT_TIERS.forEach(tier => {
      const erreicht = total >= tier.cents;
      const aktiv = !erreicht && !aktivGesetzt;
      if (aktiv) aktivGesetzt = true;
      const pct = aktiv ? Math.max(0, Math.min(100, Math.round(total / tier.cents * 100))) : 0;
      let cls = 'eona-gifts__row';
      if (erreicht) cls += ' eona-gifts__row--done';
      if (aktiv) cls += ' eona-gifts__row--active';
      rows.push(
        '<div class="' + cls + '">' +
        (aktiv ? '<span class="eona-gifts__fill" style="width:' + pct + '%"></span>' : '') +
        '<span class="eona-gifts__amount">' + euro(tier.cents).replace(',00', '') + '</span>' +
        '<span class="eona-gifts__label">' + tier.label + '</span>' +
        (erreicht ? '<span class="eona-gifts__chip eona-gifts__chip--done">\u2713</span>' : '') +
        (aktiv ? '<span class="eona-gifts__chip">noch ' + euro(tier.cents - total) + '</span>' : '') +
        '</div>'
      );
    });
    wrap.innerHTML = rows.join('');
  };

  const buildStack = () => {
    const rows = EONA_PAYMENT_ROW ? EONA_TRUST_ROWS.concat([EONA_PAYMENT_ROW]) : EONA_TRUST_ROWS;
    const div = document.createElement('div');
    div.className = 'eona-trust-stack';
    rows.forEach(pair => {
      const row = document.createElement('div');
      row.className = 'eona-trust-stack__row';
      const l = document.createElement('span');
      l.className = 'eona-trust-stack__label';
      l.textContent = pair[0];
      const w = document.createElement('span');
      w.className = 'eona-trust-stack__value';
      w.textContent = pair[1];
      row.append(l, w);
      div.appendChild(row);
    });
    return div;
  };

  const renderStacks = () => {
    document.querySelectorAll('cart-drawer .cart-drawer__footer').forEach(f => {
      if (!f.querySelector('.eona-trust-stack')) f.prepend(buildStack());
    });
    document.querySelectorAll('#main .cart-recap').forEach(r => {
      if (!r.querySelector('.eona-trust-stack')) r.appendChild(buildStack());
    });
  };

  const renderAll = () => { renderFsb(); renderStacks(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderAll);
  else renderAll();
  new MutationObserver(renderAll).observe(document.documentElement, {childList: true, subtree: true, attributes: true, attributeFilter: ['total-price']});
})();